import { Image, Text } from '@mantine/core';

// chat_ui の ConnectingScreen と同じ見た目（ロゴを明滅させ、下に「接続中…」）にそろえる
export function FullScreenLoading() {
  return (
    <output className="flex h-dvh w-full flex-col items-center justify-center gap-6 px-4">
      <Image
        className="plamo-connecting-pulse"
        src="/plm_a_full_rgb.png"
        h={32}
        w="auto"
        alt="PLaMo"
      />
      <Text size="xs" c="dimmed" className="tracking-wide">
        接続中…
      </Text>
    </output>
  );
}
